export default __webpack_public_path__ + "locales/hy-AM/Settings.json?hash=a7abfde71254966bf56218a891530cfc";